<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/PeSBZ6/tc-custom/9781783038183.jpg?1699150510463" alt="This image is the cover for the book Armoured Warfare in the North African Campaign, Images of War"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Armoured Warfare in the North African Campaign, Images of War
      </h1>
      <p class="bookDescription body article font2">
        <p>The North African campaign, the struggle of the Italians and Germans against the Allies in Egypt, Libya and Tunisia between 1940 and 1943, was a war of movement and maneuver, of dramatic changes of fortune, and it was a war in which mechanized forces—tanks in particular—excelled. Compared with the heavily populated landscapes of northwest Europe, the empty open spaces of North Africa appeared to be ideal operating terrain for tanks, yet the harsh desert conditions tested men and machinery to the limit, as Anthony Tucker-Jones demonstrates in this remarkable selection of wartime photographs.The use of armor during the entire course of the campaign is covered, from the initial Italian offensive, the arrival of Rommels Panzergruppe Afrika, the battles fought along the North African shore which culminated in El Alamein, then the Allied advance into Tunisia which led to the final defeat of the German and Italian armies.The images give a fascinating inside view of combat, but they also reveal the daily routines of tank warfare 65 years ago, and give a vivid impression of what it was like to fight in and live with the tanks of the day  the German Mk IIIs and Mk IVs and the Tiger, the British Matildas and Valentines and the American Grants and Shermans that contributed so much to the Allied victory. Training, maintenance, transportation and supply are shown, as are the daily lives of the tank crews and extreme conditions in which they worked and fought.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Anthony Tucker-Jones
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Pen and Sword
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?55e38112